import styled, { css } from 'styled-components';
import { Text } from 'breadcrumbs-ui/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const alertBgColors = {
  info: 'fill-info-subtle',
  warning: 'fill-caution-subtle',
  success: 'fill-positive-subtle',
  danger: 'fill-alert-subtle'
};
const alertBorderColors = {
  info: 'border-info-default',
  warning: 'border-caution-default',
  success: 'border-positive-default',
  danger: 'border-alert-default'
};
const AlertContainer = styled.div.withConfig({
  displayName: "Alert__AlertContainer",
  componentId: "sc-4o7d8k-0"
})(({
  level,
  theme
}) => css(["margin:", " !important;margin-bottom:0 !important;background:", " !important;padding:", " !important;border:", " solid ", " !important;color:", " !important;"], theme.space['400'], theme.color[alertBgColors[level]], theme.space['300'], theme.borderWidth['100'], theme.color[alertBorderColors[level]], theme.color['text-core-default']));
const AlertLink = styled.a.withConfig({
  displayName: "Alert__AlertLink",
  componentId: "sc-4o7d8k-1"
})(({
  theme
}) => css(["", ";color:", " !important;text-decoration:underline !important;display:block !important;&:hover{color:", " !important;}"], theme.typography['body-100'], theme.color['text-core-default'], theme.color['text-core-default']));
export const Alert = ({
  level,
  title,
  description,
  link,
  linkText
}) => {
  return /*#__PURE__*/_jsxs(AlertContainer, {
    level: level,
    children: [title && /*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-100",
      children: title
    }), description && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: description
    }), link && /*#__PURE__*/_jsx(AlertLink, {
      href: link,
      children: linkText || link
    })]
  });
};
export default Alert;